// The one home for the floor DOM-root boundary. Two gates need the exact
// same list and must never be able to drift apart: scripts/check-touch-
// only.ts (which floor HTML roots are scanned for touch-only violations)
// and scripts/check-floor-viewport.ts (which e2e specs count as floor
// because they reference one of these roots, so an "admin"-declared spec
// that actually touches the floor is a finding, not a silent pass).
//
// See scripts/check-touch-only.ts's own header for how this list was
// drawn (exactly e2e/usability.spec.ts's own FLOOR_SURFACES roots) and
// its stated KNOWN LIMIT on what is not yet decided as floor or admin.

/** The floor DOM roots, by id, in ui/index.html. */
export const FLOOR_HTML_ROOTS: readonly string[] = [
  "terminal-setup-screen",
  "user-picker-screen",
  "pin-entry-screen",
  // UX18 (DEC-061): the manager-approval picker a lounger raises mid-
  // service, reused with #pin-entry-screen above in "approval" mode.
  // CLAUDE.md's own floor list already named this ("any manager-approval
  // prompt raised from the floor"); it was left off this list only
  // because nobody had answered the question yet (check-touch-only.ts's
  // own former "KNOWN LIMIT" note). DEC-061 answers it: this screen stays
  // on the floor, unlike the Manager Exceptions REVIEW surface and
  // Closeout Summary, which UX18 moves to admin and which were never on
  // this list to begin with.
  "approval-picker-screen",
  "open-tabs-screen",
  "ring-screen",
  "admin-count-session-sheet",
  // INV1 (docs/build-briefs/INV1-movement-types.md): waste/return-to-
  // stock/vendor-return recording, shelf-side work done walking the
  // floor with a device, the identical CLAUDE.md exception
  // #admin-count-session-sheet above already carries ("Count sessions
  // are the exception inside the admin surface").
  "admin-inventory-movement-sheet",
  // PO6-R1 (DEC-056) REMOVED "purchasing-receiving-screen" and
  // "purchasing-outside-order-screen" from this list. ADR-003's original
  // Decision 2 reasoned receiving follows the floor rule by analogy to a
  // count session; the owner ruled directly that receiving is a desk
  // activity with the invoice in hand, not the shelf, which supersedes
  // that analogy. Both screens are admin surfaces now: keyboard and
  // pointer may be assumed, and their own e2e specs declare
  // ADMIN_WORKSTATION.
  // USR4 (docs/build-briefs/USR4-my-profile-details.md), surface finding
  // in design/mockups/usr4-my-profile.html's own header: #profile-screen
  // was reachable from the shared topbar (#app-topbar, UX17/DEC-059) on
  // every floor screen -- a bartender taps their own name from the ring
  // screen mid-shift and lands here with no keyboard first -- but was
  // never added to this list, so check-touch-only.ts never scanned it.
  // Added now so the gate catches it, matching where it is actually
  // reachable from.
  "profile-screen",
  // ONB4 slice 1 (docs/build-briefs/ONB4-S1-setup-wizard-frame.md): the first sign-in setup wizard runs on the
  // location's own device, so it is touch first: pickers, chips and a numeric pad, designed and tested at the floor
  // device viewport.
  "setup-wizard-screen",
  // PO7-S5 (docs/build-briefs/PO7-S5-invoice-scan-receive.md; DEC-409): the invoice-scan receive screen, designed at the
  // floor device viewport and touch only (the person stands at the delivery with the invoice and the device). It is
  // reached from the two admin receiving screens, which stay admin surfaces (DEC-056).
  "receive-scan-screen",
];
